import { z } from 'zod'

/**
 * Reusable field transforms
 */
const requiredFiniteNumber = z.number().finite() // Rejects null, NaN, Infinity - forces validation failure

const nameWithDefault = z
  .string()
  .nullable()
  .transform(value => value ?? '')

/**
 * Base audience shape shared across all audience schemas
 */
const BaseAudienceSchema = z.object({
  __typename: z.literal('ThirdPartyAudience'),
  id: z.number().int(),
  name: nameWithDefault,
})

/**
 * Schema for normalizing audience query results
 */
export const NormalizedAudienceSchema = BaseAudienceSchema.extend({
  total_users: requiredFiniteNumber,
}).transform(({ id, name, total_users }) => ({
  id,
  name,
  totalUsers: total_users,
}))

export type NormalizedAudience = z.output<typeof NormalizedAudienceSchema>

/**
 * Schema for normalizing audience preview results
 * Uses total_users as the audience size metric
 * Strictly requires a valid finite number - null/NaN/Infinity will fail validation
 */
export const NormalizedAudiencePreviewSchema = BaseAudienceSchema.extend({
  total_users: requiredFiniteNumber,
}).transform(({ id, name, total_users }) => ({
  id,
  name,
  availableAudienceSize: total_users,
}))

export type NormalizedAudiencePreview = z.output<typeof NormalizedAudiencePreviewSchema>

export const GeoLocationSearchResultSchema = z.object({
  id: z.number(),
  locationId: z.number(),
  location: z.string(),
  subLocation1: z.string().nullable(),
  subLocation2: z.string().nullable(),
  locationType: z.string().nullable(),
  devices: z.number().nullable(),
})

export type GeoLocationSearchResult = z.output<typeof GeoLocationSearchResultSchema>
